import React from 'react';
import './index.scss';
import classNames from 'classnames';

const FancyCard = (props) => {
  const { className, style, children } = props;

  return (
    <div className={classNames('chatai-ui-fancycard', className)} style={style}>
      <div className="chatai-ui-fancycard-blob blob1" />
      <div className="chatai-ui-fancycard-blob blob2" />
      <div className="chatai-ui-fancycard-blob blob3" />
      <div className="chatai-ui-fancycard-blob blob4" />
      <div className="chatai-ui-fancycard-blob blob5" />
      <div className="chatai-ui-fancycard-blob blob6" />
      <div className="chatai-ui-fancycard-blob blob7" />
      <div className="chatai-ui-fancycard-blob blob8" />
      <div className="chatai-ui-fancycard-blob blob9" />
      <div className="chatai-ui-fancycard-content">{children}</div>
    </div>
  );
};

export default FancyCard;
